const uploadImage = (editor) => {

    editor.BlockManager.add('uploadimage',{
        category: 'Components',
        label: `
            <i class="fas fa-upload"></i>
            <div class="gjs-fontFamily gjs-block-label">Upload image</div>
          `,
        attributes: {},
        content: `
            <div class="mb-3">
                <label for="formFile" class="form-label">Default file input example</label>
                <input class="form-control" type="file" id="formFile">
            </div>
          `
    })

}

export default uploadImage;